// extracted by css-extract-rspack-plugin
export default {"fakeMagrittePrimaryText":"fake-magritte-primary-text--zBRANxp34k9768tD"};